import "./style.css";
import {useEffect, useState} from "react";
import SearchForm from "../common/searchForm/SearchForm";
import {LicenseSearchFormProps} from "./constants/SearchForm.props";
import List from "../common/list/List";
import Pagination from "../common/pagination/Pagination";
import {InitialListProps, ListColumnType, ListProps} from "../common/list/List.props";
import * as LicenseListProps from "./constants/LicenseList.props";
import {InitialPaginationPropsForUse, PaginationPropsForUse} from "../common/pagination/Pagination.props";
import {LicenseTypeDto} from "./dto/LicenseType.dto";
import axios from "axios";
import * as ApiUrl from "../../constants/ApiUrl";
import * as Query from "../../constants/query/License.query";
import {Option} from "../common/searchForm/Option";
import {SearchFormPropsForUse} from "../common/searchForm/SearchForm.props";
import {LicenseUserDto} from "./dto/LicenseUser.dto";
import {PopupProps} from "../common/popup/Popup.props";
import Popup from "../common/popup/Popup";
import {saveAs} from "file-saver";
import {useNavigate} from "react-router-dom";
import {LICENSE_DETAIL} from "../../constants/Routes";

export default function License() {
    const [popup, setPopup] = useState<PopupProps | null>(null);
    const [currentLicenseType, setCurrentLicenseType] = useState<number>(0);
    const [searchProps, setSearchProps] = useState<SearchFormPropsForUse>(LicenseSearchFormProps());
    const [totalUserCount, setTotalUserCount] = useState<number>(0);
    const [listProps, setListProps] = useState<ListProps<LicenseUserDto>>(InitialListProps);
    const [paginationProps, setPaginationProps] = useState<PaginationPropsForUse>(InitialPaginationPropsForUse);
    const [licenseTypes, setLicenseTypes] = useState<LicenseTypeDto[]>([]);

    const navigate = useNavigate();

    useEffect(() => {
        setListProps({
            headers: LicenseListProps.HEADERS,
            items: [],
            emptyProps: InitialListProps.emptyProps,
            onCheckedChange: (seqs: number[]) => setItemChecked(seqs)
        });
    }, []);

    useEffect(() => {
        if (licenseTypes.length === 0) {
            axios.post(ApiUrl.GRAPHQL, {query: Query.GET_LICENSE_TYPES}).then(
                response => {
                    getLicenseUsers(0);
                    setLicenseTypes(response.data.data.getLicenseTypes);
                    setSearchProps({
                        options: LicenseSearchFormProps(response.data.data.getLicenseTypes).options,
                        onUpdate: (options: Option[]) => {
                            setSearchProps(prevState => ({
                                ...prevState,
                                options: options
                            }));
                        }
                    });
                }
            ).catch(error => console.log(error));
        } else {
            setCurrentLicenseType(licenseTypes[0].type);
        }
    }, [licenseTypes]);

    useEffect(() => {
        if (listProps.items.length > 0) {
            if (LicenseListProps.HEADERS.find(header => header.type === ListColumnType.BUTTON)) {
                LicenseListProps.HEADERS.pop();
            }

            LicenseListProps.HEADERS.push({
                type: ListColumnType.BUTTON,
                name: "",
                key: "",
                button: {
                    name: "상세 보기",
                    onClick: (seq: number) => onButtonClick(seq, listProps.items)
                }
            });

            setListProps(prevState => ({
                ...prevState,
                headers: LicenseListProps.HEADERS
            }));
        }
    }, [listProps.items]);

    const setItemChecked = (seqs: number[]) => {
        setListProps(prevState => ({
            ...prevState,
            items: prevState.items.map(item => {
                item.checked = seqs.includes(item.seq!);
                return item;
            })
        }));
    }

    const getLicenseUsers = (page: number) => {
        let userTypes: number[] = [];
        let licenseTypes: number[] = [];

        searchProps.options[0].value.forEach((isChecked: boolean, index: number) => {
            if (isChecked) {
                userTypes.push(searchProps.options[0].list[index]);
            }
        });

        searchProps.options[1].value.forEach((isChecked: boolean, index: number) => {
            if (isChecked) {
                licenseTypes.push(searchProps.options[1].list[index]);
            }
        });

        axios.post(ApiUrl.GRAPHQL, {
            query: Query.GET_LICENSE_USERS(
                page,
                userTypes,
                licenseTypes,
                searchProps.options[2].value.type,
                searchProps.options[2].value.text
            )
        }).then(
            response => {
                setPaginationProps(prevState => ({
                    ...prevState,
                    currentPage: page,
                    totalPage: response.data.data.getLicenseUsers.totalPage,
                }));
                setListProps(prevState => ({
                    ...prevState,
                    items: response.data.data.getLicenseUsers.items
                }));
                setTotalUserCount(response.data.data.getLicenseUsers.totalItems);
            }).catch(error => console.log(error));
    }

    const saveSelected = () => {
        let selectedItems: LicenseUserDto[] = listProps.items.filter(item => item.checked);

        if (selectedItems.length === 0) {
            setPopup({
                subject: "라이선스 사용자 목록 엑셀 저장",
                message1: "저장할 항목을 선택해 주세요.",
                message2: "",
                buttonName: "확인",
                onConfirm: () => setPopup(null),
                useCloseButton: false,
                onClose: () => {
                }
            });

            return;
        }

        axios.post(ApiUrl.EXPORT_LICENSES_TO_EXCEL, selectedItems.map(item => item.seq), {responseType: "blob"})
            .then(response => {
                saveAs(response.data, "라이선스 사용자 목록.xlsx");
            }).catch(error => console.log(error));
    }

    const saveAll = () => {
        axios.post(ApiUrl.EXPORT_LICENSES_TO_EXCEL, [], {responseType: "blob"})
            .then(response => {
                saveAs(response.data, "라이선스 사용자 목록.xlsx");
            }).catch(error => console.log(error));
    }

    const onButtonClick = (seq: number, licenseUsers: LicenseUserDto[]) => {
        const licenseUser: LicenseUserDto | undefined = licenseUsers.find(item => item.seq === seq);
        navigate(LICENSE_DETAIL, {state: {seq: seq, email: licenseUser?.email, name: licenseUser?.name}});
    }

    return (
        <>
            <div className="license-management">
                <div className="wrapper">
                    <div className="license-body">
                        <div className="license-head">
                            라이선스 관리
                        </div>
                        <section className="list-search-section">
                            <div className="title">
                                사용자 내역
                            </div>
                            {searchProps.options[1].list.length &&
                                <SearchForm {...searchProps} onSearch={() => getLicenseUsers(0)}/>}
                        </section>
                        <div className="member-numbers">
                            <div className="member-wrapper">
                                <div className="member-all-number">
                                    사용 회원 수 {totalUserCount}명
                                </div>
                                <div className="member-choice">
                                    <button onClick={() => saveAll()} className="save">
                                        전체 엑셀저장
                                    </button>
                                    <button onClick={() => saveSelected()} className="save">
                                        선택항목 엑셀저장
                                    </button>
                                </div>
                            </div>
                            <List {...listProps}/>
                        </div>
                        <Pagination {...paginationProps} onChange={getLicenseUsers}/>
                    </div>
                </div>
            </div>
            {popup && <Popup data={popup}/>}
        </>
    );
}